module.exports = __webpack_public_path__ + "static/item_sort_order-c42daa17fcca773fc1591bfdbe3eb1cc.png";